module.exports = __webpack_public_path__ + "img/2.d51285e3.jpg";